<template>
  <v-card flat>
    <v-speed-dial v-model="fab" small right absolute direction="left">
      <v-btn slot="activator" small v-model="fab" color="primary" dark fab>
        <v-icon>more_horiz</v-icon>
        <v-icon>close</v-icon>
      </v-btn>

      <v-btn
        v-for="(action,action_index) in actions"
        :key="action_index"
        fab
        dark
        small
        :disabled="action.disabled"
        :color="action.color"
        @click="runAction(action)"
      >
        <v-icon>{{ action.icon }}</v-icon>
      </v-btn>
    </v-speed-dial>
  </v-card>
</template>

<script>
export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    context: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    fab: false
  }),
  methods: {
    runAction(action) {
      if (typeof action.event === "string") {
        this.$emit(action.event, this.context);
      } else if (typeof action.event === "function") {
        action.event(this.context);
      } else if (
        action.event instanceof Object &&
        typeof action.event.action === "string"
      ) {
        this.$store
          .dispatch(action.event.action, this.context, { root: true })
          .then(val => console.log("runAction", val))
          .catch(err => console.error("runAction", err));
      } else {
        console.error("Unknown action event", action.event);
      }
    }
  }
};
</script>
